import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { useSettings } from "@/context/SettingsContext";

const SOCIAL_FIELDS = [
  ["instagram_url", "Instagram URL"], ["tiktok_url", "TikTok URL"],
  ["pinterest_url", "Pinterest URL"], ["facebook_url", "Facebook URL"],
  ["youtube_url", "YouTube URL"], ["default_share_image", "Default Social Share Image URL"],
];

export default function SocialMarketing() {
  const { refresh } = useSettings();
  const [data, setData] = useState(null);
  const [saving, setSaving] = useState(false);
  useEffect(() => { api.get("/admin/settings").then((r) => setData(r.data)); }, []);
  if (!data) return <div className="text-parchment/70">Loading…</div>;

  const upd = (k, v) => setData((s) => ({ ...s, social: { ...(s.social || {}), [k]: v } }));
  const save = async () => {
    setSaving(true);
    try {
      // Basic URL validation
      for (const [k] of SOCIAL_FIELDS.filter(([kk]) => kk !== "default_share_image")) {
        const v = data.social?.[k];
        if (v && !/^https?:\/\//i.test(v)) throw new Error(`Invalid URL for ${k}: must start with http(s)://`);
      }
      await api.put("/admin/settings", { social: data.social });
      await refresh();
      toast.success("Social links saved");
    } catch (e) { toast.error(e.message || "Save failed"); }
    finally { setSaving(false); }
  };

  return (
    <div>
      <div className="flex items-center gap-4 mb-6">
        <h1 className="font-display text-2xl sm:text-3xl text-gold flex-1">Social &amp; Marketing</h1>
        <button data-testid="social-save" onClick={save} disabled={saving} className="btn-gold text-xs">
          {saving ? "Saving…" : "Save"}
        </button>
      </div>
      <div className="curio-card p-6 space-y-4 max-w-2xl">
        <p className="text-parchment/60 text-sm italic">Empty fields are hidden from the storefront. Only fields with valid https:// URLs display their social icons.</p>
        {SOCIAL_FIELDS.map(([k, label]) => (
          <div key={k}>
            <label className="font-caption text-[10px] text-brass block mb-1">{label}</label>
            <input className="input-vintage" placeholder="https://…" value={data.social?.[k] || ""}
              data-testid={`social-${k}`}
              onChange={(e) => upd(k, e.target.value)} />
          </div>
        ))}
      </div>
    </div>
  );
}
